import {useContext} from 'react';
import {Utils} from '../Utils';
import {AppContext} from '../App';
import './Header.css';
import Icon from '../assets/logo.jsx';
// import LangSwImg from '../assets/lang-sw.svg';

export function Header()
{
	const { lang, setLang } = useContext(AppContext);
	let siteName = Utils.tr('SITE_NAME');
	let nameElm;
	if(lang === 'en')
	{
		let parts = siteName.split(' ');
		nameElm = <>
			<span className="pa-1">{parts[0]}</span>
			<span className="pa-2"> {parts[1]}</span>
		</>;
	}
	else
	{
		nameElm = <span className="pa-1">{siteName}</span>;
	}

	const onLangChange = (evt) =>
	{
		setLang(evt.target.value);
	};

	const onLogoClick = (evt) =>
	{
		window.location.reload();
	};

	let langs = {
		'en': Utils.tr('LANG_EN'),
		'cn': Utils.tr('LANG_CN')
	};
	return (
		<header id="header">
			<div className="logo">
				<a href="#" onClick={onLogoClick}>
					<Icon />
				</a>

				<div className="control has-icons-left lang-sw">
					<div className="select">
						<select onChange={onLangChange} defaultValue={lang}>
						{
							Object.keys(langs).map((k, i) =>
							{
								return (
									<option key={i} value={k}>{langs[k]}</option>
								);
							})
						}
						</select>
					</div>
					<span className="icon is-large is-left">
						<i className="fas fa-globe"></i>
					</span>
				</div>
			</div>
			<div className="site-name title">{nameElm}</div>
		</header>
	);
}